import $ from 'jquery';
import videojs from 'video.js';

class CVolumeMenuButton extends videojs.getComponent('VolumePanel') {
  createEl() {
    const el = super.createEl();
    const $el = $(el);
    $el.attr('data-js', 'video-mute-control');
    $el.addClass('c-video-control c-volume-menu-button vjs-menu-button-popup');
    return el;
  }
}

videojs.registerComponent('CVolumeMenuButton', CVolumeMenuButton);
